/**
 * Reviews Carousel Section - Judge.me Integration
 */

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  const reviewCarousels = document.querySelectorAll('[data-section-type="reviews-carousel"]');
  
  reviewCarousels.forEach(function(sectionEl) {
    const sectionId = sectionEl.getAttribute('data-section-id');
    const carouselEl = document.getElementById('reviews-carousel-' + sectionId);
    const reviewsWrapper = carouselEl ? carouselEl.querySelector('#reviews-wrapper') : null;
    const headerEl = document.getElementById('judge-me-header');
    
    // Get settings from data attributes
    const shopDomain = sectionEl.getAttribute('data-shop-domain') || 'workboots-direct.myshopify.com';
    const apiToken = sectionEl.getAttribute('data-api-token') || 'LNx1ib4-5NrsDMYbHipq1UcxF1k';
    const privateApiToken = sectionEl.getAttribute('data-private-api-token') || 'p5DLA-stIPz_46ih6la7l55hvP0';
    const slidesPerView = carouselEl ? parseInt(carouselEl.getAttribute('data-slides-per-view')) || 3 : 3;
    const slidesPerViewTablet = carouselEl ? parseInt(carouselEl.getAttribute('data-slides-per-view-tablet')) || 2 : 2;
    const spaceBetween = carouselEl ? parseInt(carouselEl.getAttribute('data-space-between')) || 24 : 24;
    const speed = carouselEl ? parseInt(carouselEl.getAttribute('data-speed')) || 600 : 600;
    const autoplay = carouselEl ? carouselEl.getAttribute('data-autoplay') === 'true' : true;
    const autoplayDelay = carouselEl ? parseInt(carouselEl.getAttribute('data-autoplay-delay')) || 5000 : 5000;
    const reverseAutoplay = carouselEl ? carouselEl.getAttribute('data-reverse-autoplay') === 'true' : false;
    const enableSwipe = carouselEl ? carouselEl.getAttribute('data-enable-swipe') !== 'false' : true;
    const showNavigation = carouselEl ? carouselEl.getAttribute('data-show-navigation') !== 'false' : true;
    const showPagination = carouselEl ? carouselEl.getAttribute('data-show-pagination') === 'true' : false;
    
    // Function to fetch average rating from Judge.me API
    function loadAverageRating() {
      // Use private token if available, otherwise fall back to public token
      const token = privateApiToken || apiToken;
      const url = 'https://api.judge.me/api/v1/widgets/average_rating?shop_domain=' + shopDomain + '&api_token=' + token;
      
      fetch(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data && data.average_rating !== undefined) {
            updateHeader(data.average_rating, data.total_reviews || 0);
          }
        })
        .catch(function(error) {
          console.log('Could not load average rating, using default');
          // Still show header with default values
          updateHeader(4.83, 438);
        });
    }
    
    // Update header with rating data
    function updateHeader(rating, reviewCount) {
      if (!headerEl) return;
      
      var starsContainer = headerEl.querySelector('.jdgm-stars');
      var ratingText = headerEl.querySelector('.jdgm-rating-text');
      
      // Update stars based on rating
      if (starsContainer) {
        var stars = starsContainer.querySelectorAll('.jdgm-star');
        var fullStars = Math.round(rating);
        
        stars.forEach(function(star, index) {
          if (index < fullStars) {
            star.classList.add('jdgm--on');
            star.classList.remove('jdgm--off');
          } else {
            star.classList.remove('jdgm--on');
            star.classList.add('jdgm--off');
          }
        });
      }
      
      // Update rating text
      if (ratingText) {
        ratingText.innerHTML = rating.toFixed(2) + ' ★ (<span class="jdgm-reviews-count">' + reviewCount + '</span>)';
      }
      
      // Show the header
      headerEl.style.display = 'block';
    }
    
    // Function to fetch reviews from Judge.me widget endpoint
    function loadReviews() {
      // Fetch the widget HTML from Judge.me - using the same endpoint their widget uses
      var url = 'https://api.judge.me/api/v1/widgets/all_reviews_page?shop_domain=' + shopDomain + '&api_token=' + apiToken + '&per_page=20&page=1&review_type=product-reviews';
      
      fetch(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          // The API returns JSON with HTML in 'all_reviews' field
          if (data && data.all_reviews) {
            parseWidgetHtml(data.all_reviews);
          } else {
            showFallbackReviews();
          }
        })
        .catch(function(error) {
          console.error('Error loading Judge.me widget:', error);
          showFallbackReviews();
        });
    }
    
    // Parse widget HTML to extract review data
    function parseWidgetHtml(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      
      // Find all review cards - look for jdgm-card elements
      var cardElements = doc.querySelectorAll('.jdgm-card');
      
      var reviews = [];
      
      cardElements.forEach(function(card) {
        // Skip clone elements (before/after)
        if (card.classList.contains('jdgm-clone-before') || card.classList.contains('jdgm-clone-after')) {
          return;
        }
        
        // Extract image
        var imgEl = card.querySelector('img');
        var imageUrl = imgEl ? imgEl.src : '';
        
        // Extract review text
        var textEl = card.querySelector('.jdgm-text p');
        var reviewText = textEl ? textEl.textContent.trim() : '';
        
        // Extract stars
        var starsContainer = card.querySelector('.jdgm-stars');
        var rating = 0;
        if (starsContainer) {
          var stars = starsContainer.querySelectorAll('.jdgm-star.jdgm--on');
          rating = stars.length;
        }
        
        // Extract reviewer name
        var nameEl = card.querySelector('.jdgm-reviewer-name');
        var reviewerName = nameEl ? nameEl.textContent.trim() : 'Customer';
        
        // Check for verified badge
        var verifiedEl = card.querySelector('.jdgm-reviewer-verified-icon');
        var isVerified = verifiedEl !== null;
        
        // Extract product name and link
        var productEl = card.querySelector('.jdgm-product-name a');
        var productTitle = productEl ? productEl.textContent.trim() : '';
        var productLink = productEl ? productEl.href : '';
        
        // Only add if we have meaningful content
        if (reviewText || imageUrl) {
          reviews.push({
            image: imageUrl,
            text: reviewText,
            rating: rating,
            author: reviewerName,
            verified: isVerified,
            productTitle: productTitle,
            productLink: productLink
          });
        }
      });
      
      if (reviews.length > 0) {
        renderReviews(reviews);
      } else {
        showFallbackReviews();
      }
    }
    
    // Function to render reviews in carousel
    function renderReviews(reviews) {
      if (!reviewsWrapper) return;
      
      reviews.forEach(function(review) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide reviews-carousel__item';
        
        // Build star rating HTML
        var starsHtml = '';
        for (var i = 1; i <= 5; i++) {
          if (i <= review.rating) {
            starsHtml += '<span class="reviews-carousel__star reviews-carousel__star--on"></span>';
          } else {
            starsHtml += '<span class="reviews-carousel__star reviews-carousel__star--off"></span>';
          }
        }
        
        // Build verified icon if verified buyer
        var verifiedHtml = review.verified ? `
          <span class="reviews-carousel__verified-icon">
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16">
              <path d="M8.9375 10.875L7.6875 9.64583C7.53472 9.49306 7.36111 9.41667 7.16667 9.41667C6.97222 9.41667 6.79861 9.49306 6.64583 9.64583C6.49306 9.79861 6.41667 9.97569 6.41667 10.1771C6.41667 10.3785 6.49306 10.5556 6.64583 10.7083L8.41667 12.4792C8.56944 12.6319 8.74306 12.7083 8.9375 12.7083C9.13194 12.7083 9.30556 12.6319 9.45833 12.4792L13.3542 8.58333C13.5069 8.43056 13.5833 8.25347 13.5833 8.05208C13.5833 7.85069 13.5069 7.67361 13.3542 7.52083C13.2014 7.36806 13.0278 7.29167 12.8333 7.29167C12.6389 7.29167 12.4653 7.36806 12.3125 7.52083L8.9375 10.875ZM10 18C8.90278 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0764 2.625 13.1042C2.20833 12.1319 2 11.0972 2 10C2 8.88889 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92361 3.04167 6.89583 2.625C7.86806 2.20833 8.90278 2 10 2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6562 4.34375C16.3854 5.07292 16.9583 5.92014 17.375 6.88542C17.7917 7.85069 18 8.88889 18 10C18 11.0972 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6562 15.6562C14.9271 16.3854 14.0799 16.9583 13.1146 17.375C12.1493 17.7917 11.1111 18 10 18Z"></path>
            </svg>
          </span>
        ` : '';
        
        // Build image if available
        var imageHtml = '';
        if (review.image) {
          imageHtml = '<img src="' + review.image + '" alt="Review image" class="reviews-carousel__image" loading="lazy">';
        }
        
        // Build product link
        var productHtml = '';
        if (review.productTitle) {
          var productUrl = review.productLink || '#';
          productHtml = '<div class="reviews-carousel__product"><a href="' + productUrl + '" target="_blank" rel="noopener noreferrer">' + review.productTitle + '</a></div>';
        }
        
        // Build the card HTML (escape HTML to sanitize)
        var reviewBody = review.text ? review.text.replace(/</g, '<').replace(/>/g, '>') : '';
        
        slide.innerHTML = imageHtml + 
          '<div class="reviews-carousel__content">' +
            '<div class="reviews-carousel__rating-section">' +
              '<div class="reviews-carousel__stars">' + starsHtml + '</div>' +
            '</div>' +
            '<div class="reviews-carousel__text"><p>' + reviewBody + '</p></div>' +
            '<div class="reviews-carousel__reviewer-info">' +
              '<span class="reviews-carousel__reviewer-name">' + review.author + '</span>' +
              verifiedHtml +
            '</div>' +
            productHtml +
          '</div>';
        
        reviewsWrapper.appendChild(slide);
      });
      
      // Initialize Swiper after reviews are loaded
      initSwiper();
    }
    
    // Fallback function to show sample reviews if API fails
    function showFallbackReviews() {
      if (!reviewsWrapper) return;
      
      var fallbackReviews = [
        {
          image: '',
          text: "Love these boots! Great fit and very comfortable. Highly recommend!",
          rating: 5,
          author: "Wayne",
          verified: true,
          productTitle: "Mongrel 910025 L/U Non-Safety Shoe",
          productLink: "/products/mongrel-910025-l-u-non-safety-shoe"
        },
        {
          image: '',
          text: "Best work boots I have ever had. Bought a spare set.",
          rating: 5,
          author: "Daniel Ganzenmuller",
          verified: true,
          productTitle: "Redback - Steel Toe Safety Boot USBOK",
          productLink: "/products/redback-steel-toe-safety-boot-usbok-1"
        },
        {
          image: '',
          text: "Excellent service, excellent boots. Fast delivery too!",
          rating: 5,
          author: "ian c warne",
          verified: true,
          productTitle: "Mongrel 315085 Slip on Safety Shoe",
          productLink: "/products/mongrel-315085-slip-on-safety-shoe"
        },
        {
          image: '',
          text: "Good work boots comfortable to wear all day",
          rating: 5,
          author: "Ashley Mcclure",
          verified: true,
          productTitle: "Mack Octane Zip Boot Safety Composite",
          productLink: "/products/mack-octane-zip-boot-safety-composite"
        },
        {
          image: '',
          text: "Best work boot on the market. Comfortable. Lightweight & easy to put on and off",
          rating: 5,
          author: "Mark Daniel",
          verified: true,
          productTitle: "Mongrel 261050 Zip Safety Boot",
          productLink: "/products/mongrel-zip-safety-boot"
        },
        {
          image: '',
          text: "Been wearing the FXD boots on site and they're bloody comfortable. Light on the feet, no break-in time.",
          rating: 5,
          author: "Lachlan",
          verified: false,
          productTitle: "FXD WB-7 Evo-1 Safety Boot",
          productLink: "/products/fxd-wb-7-evo-1-safety-boot"
        }
      ];
      
      renderReviews(fallbackReviews);
    }
    
    // Initialize Swiper
    function initSwiper() {
      if (carouselEl && typeof Swiper !== 'undefined') {
        var swiperConfig = {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          loop: true,
          loopedSlides: 3,
          simulateTouch: enableSwipe,
          allowTouchMove: enableSwipe,
          autoplay: autoplay ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            reverseDirection: reverseAutoplay
          } : false,
          speed: speed,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 16
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 16
            },
            768: {
              slidesPerView: slidesPerViewTablet,
              spaceBetween: spaceBetween
            },
            1024: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetween
            }
          }
        };
        
        if (showNavigation) {
          swiperConfig.navigation = {
            nextEl: carouselEl.querySelector('.swiper-button-next'),
            prevEl: carouselEl.querySelector('.swiper-button-prev'),
          };
        } else {
          swiperConfig.navigation = false;
        }
        
        if (showPagination) {
          swiperConfig.pagination = {
            el: carouselEl.querySelector('.swiper-pagination'),
            clickable: true,
          };
        }
        
        new Swiper(carouselEl, swiperConfig);
      }
    }
    
    // Load reviews on page load
    loadReviews();
    loadAverageRating();
  });
});
